/**
 * Text that is not part of the shop's copy: failures, progress and accessible labels. Everything a
 * merchant can reword lives in the config catalog (`t('…')`), not here.
 */
export const UI = {
  loadError: 'This page could not be loaded. Please refresh and try again.',
  genericError: 'Something went wrong. Please try again.',
  stepsLabel: 'Claim steps',
  quantity: 'Quantity',
  decrease: 'Decrease quantity',
  increase: 'Increase quantity',
  remove: 'Remove',
  uploading: 'Uploading…',
  uploadLimit: (max: number) => `You can upload up to ${max} files.`,
  uploadTooLarge: (name: string) => `${name} is larger than 8 MB.`,
  notesRequired: 'Please explain the issue.',
  uploadRequired: 'Please upload at least one photo or document.',
  otpResent: 'A new code has been sent.',
  otpPending: (email: string) => `A code is on its way to ${email}. It may take a minute.`,
  required: 'Required',
  addressInvalid: 'Please complete the required address fields.',
  address: {
    firstName: 'First name',
    lastName: 'Last name',
    address1: 'Address',
    address2: 'Apartment, suite, etc.',
    city: 'City',
    province: 'State / Province',
    zip: 'ZIP / Postal code',
    countryCode: 'Country code (e.g. US)',
    phone: 'Phone',
  },
} as const;
